import { NavPage } from '@/components/breadcrumbs/Breadcrumbs';
import { CataloguePageHeader } from '@/components/catalogue/Header';
import { Button } from '@/components/form/Button';
import { ButtonVariant } from '@/components/form/buttonHelper';
import SiChevronLeft from '@/icons/SiChevronLeft';
import { useCurrentPurchaseOrderLink } from '@/lib/getMyLinks';
import { useCatalogueRoutePrefix } from '@/services/catalogue/useCatalogueRoutePrefix';
import {
  usePoName,
  usePoSelectedMainDevices,
  usePoSelectedPeripherals
} from '@/services/purchaseOrders/usePurchaseOrderService';
import { PurchaseOrderStep, usePONavigateAndValidate } from '@/services/purchaseOrders/validation/purchaseOrderHooks';
import { FC } from 'react';
import { useParams } from 'react-router';
import PurchaseOrderConfirmOrderDeviceFeeSection from './deviceFee/PurchaseOrderConfirmOrderDeviceFeeSection';
import PurchaseOrderConfirmOrderDetails from './PurchaseOrderConfirmOrderDetails';
import PurchaseOrderConfirmOrderDeviceSection from './PurchaseOrderConfirmOrderDeviceSection';

export const PurchaseOrderConfirmOrderPage: FC = () => {
  const navigateAndValidate = usePONavigateAndValidate();

  const poLink = useCurrentPurchaseOrderLink();

  const { orderId } = useParams();
  const poName = usePoName();
  const nameToDisplay = poName || 'Create';

  const breadcrumbs: NavPage[] = [
    {
      name: 'Orders / Quotes',
      to: poLink
    },
    {
      name: nameToDisplay,
      to: `${poLink}/${orderId}/poCatalogue`
    },
    {
      name: 'Confirm Order',
      to: ''
    }
  ];

  const routePrefix = useCatalogueRoutePrefix();

  const mainDeviceList = usePoSelectedMainDevices();

  const peripheralDeviceList = usePoSelectedPeripherals();

  return (
    <div className="flex h-full flex-1 flex-col bg-white bg-opacity-50">
      <CataloguePageHeader title={nameToDisplay} subtitle={'Confirm Order'} breadcrumbs={breadcrumbs}>
        <div className="flex gap-4">
          {/*<HelpButton />*/}
          <Button
            onClick={() =>
              navigateAndValidate(`${routePrefix}/poCatalogue/deliveryDetails`, PurchaseOrderStep.DELIVERY)
            }
            variant={ButtonVariant.Mono}
          >
            <SiChevronLeft className="text-xl" />
            <span>Back to Delivery Details</span>
          </Button>
        </div>
      </CataloguePageHeader>
      <div className="px-6 py-8 overflow-y-auto space-y-5">
        <div className="space-y-10">
          <PurchaseOrderConfirmOrderDeviceSection />
          {mainDeviceList.length > 0 && <PurchaseOrderConfirmOrderDeviceFeeSection devices={mainDeviceList} />}
          {mainDeviceList.length === 0 && peripheralDeviceList.length === 0 && (
            <div>No devices or peripherals have been added to the order yet.</div>
          )}
        </div>

        <Button
          onClick={() => navigateAndValidate(`${routePrefix}/poCatalogue`, PurchaseOrderStep.SELECT_PRODUCTS)}
          variant={ButtonVariant.Secondary}
        >
          Add Products
        </Button>

        <PurchaseOrderConfirmOrderDetails />
      </div>
    </div>
  );
};
